import React from 'react';

// icons
import IconReset from '../../../assets/ic-reset.svg';

// styles
import './chartResetButton.scss';

interface ChartResetButtonProps {
  disabled?: boolean;
  onClick: () => void;
}

const ChartResetButton = (props: ChartResetButtonProps) => {
  const handleClick = () => {
    props.onClick();
  };

  return (
    <button className="chartResetButton" onClick={handleClick} disabled={props.disabled}>
      <IconReset />
    </button>
  );
};

export default ChartResetButton;
